angular.module('zc.zenclerkS')

  .component('zcsExcludePageEditor', {
    bindings: {
      project: '='
    },
    templateUrl: '/templates/zenclerk_s/directives/exclude_page_editor/exclude_page_editor.html',
    controllerAs: 'vm',
    controller: function($scope, MongoHistory, PageType) {
      const vm = this;
      // This limit also exists in project.rb...
      const EXCLUDE_PAGE_TYPE_LIMIT = 500;

      // Calculate exclusion percentage from the most recent 1000 histories
      const EXCLUDE_PAGES_HISTORY_SAMPLING_SIZE = 1000;
      $scope.exclusionPercentage = 0;

      $scope.$on('uploadedPageTypes', function(event, pageTypes) {
        vm.pageTypes = pageTypes;
      });

      $scope.project = vm.project;

      this.$onInit = () => {
        vm.baseUrl = vm.project.base_url;
        vm.pageTypes = [];
        vm.pageTypeSampleUrls = [];
        vm.excludedPageTypeLimit = EXCLUDE_PAGE_TYPE_LIMIT;
        // get rid of last / if it's there
        if(vm.baseUrl && vm.baseUrl.endsWith('/')) {
          vm.baseUrl = vm.baseUrl.substr(0, vm.baseUrl.length - 1);
        }

        PageType.all(vm.project.id)
          .then(pageTypes => {
            vm.pageTypes = _.filter(pageTypes, pt => pt.page_type === 'no_publish');
            if(vm.pageTypes.length === 0) {
              vm.pageTypes.push(PageType.new({
                project_id: vm.projectId,
                page_type: 'no_publish',
                match_pattern: '/',
                match_type: 'prefix'
              }));
            } else {
              vm.queryMongoHistoryToCalcExclusionPercentage();
            }
          });

        vm.showExcludeForm = false;
      };

      vm.onDestroy = pageType => {
        if(!pageType) return;
        vm.pageTypes.splice(vm.pageTypes.indexOf(pageType), 1);
      };

      vm.queryMongoHistoryToCalcExclusionPercentage = () => {
        MongoHistory.find(
          { apikey: vm.project.apikey },
          { sort: { opened_at: -1 } },
          { limit: EXCLUDE_PAGES_HISTORY_SAMPLING_SIZE }
        ).then(histories => {
          if(histories) {
            vm.calcExclusionPercentage(vm.pageTypes, histories);
          }
        });
      };

      vm.calcExclusionPercentage = (pageTypes, histories) => {
        const totalCount = histories.length;
        const matchedCount = _.filter(histories, history => {
          if(!history.url || history.url.length === 0) {
            return false;
          }
          const url = new URL(history.url);
          const urlPath = `${url.pathname}${url.search}${url.hash}`;
          return _.some(pageTypes, pageType => {
            switch (pageType.match_type) {
              case 'prefix':
                if(urlPath.startsWith(pageType.match_pattern)) {
                  return true;
                }
                break;
              case 'full':
                if(urlPath === pageType.match_pattern) {
                  return true;
                }
                break;
              case 'partial':
                if(urlPath.includes(pageType.match_pattern)) {
                  return true;
                }
                break;
            }
            return false;
          });
        }).length;
        $scope.exclusionPercentage = totalCount ? (matchedCount / totalCount * 100).toFixed(2) : 0;
      };
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/exclude_page_editor/exclude_page_editor.js